import { Component } from '@angular/core';

@Component({
  selector: 'phc-cash-payment-image-component',
  templateUrl: './cash-payment.component.html',
  styleUrls: ['./cash-payment.component.scss']
})
export class CashPaymentComponent  {

 
}
